import type { TicketDetail } from '@nightshift/ui-types';

import './policy-approval.css';

/**
 * Says, where nobody can miss it, that no person approved this landing.
 *
 * Shown in Merging and Done when the landing was approved by the project's auto-merge policy.
 * The reasons are the facts the policy checked, so the reader knows exactly what was looked at
 * and what was not.
 */
export function PolicyApprovalBanner({ detail }: { detail: TicketDetail }) {
  const approval = detail.policyApproval;
  if (!approval) return null;
  if (detail.ticket.state !== 'Merging' && detail.ticket.state !== 'Done') return null;
  return (
    <section className="policy-approval" role="note" aria-label="Auto-approved by policy">
      <p className="policy-approval-head">
        <strong>Auto-approved by policy</strong>
        <span className="dim">
          {' '}
          <code>{approval.policy}</code>
          {approval.sha ? (
            <>
              {' at '}
              <span className="mono">{approval.sha.slice(0, 8)}</span>
            </>
          ) : null}
          {' · no person reviewed this change'}
        </span>
      </p>
      {approval.reasons.length > 0 ? (
        <ul className="policy-approval-reasons">
          {approval.reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
